/* KYME ACTIVE — shared size chart data (PDP drawer + size guide page) */
window.KymeSizeGuide = (function () {
  'use strict';

  var sizeCharts = [
    {
      slug: 'sculpt-racerback-bra',
      name: 'SCULPT™ Racerback Bra',
      group: 'Bras',
      note: 'Seamless twist back · JY 4198',
      match: ['sculpt™ racerback bra'],
      tables: [{ columns: ['Size', 'Length', 'Bust', 'Bottom'], rows: [
        ['XS', 18, 60, 52], ['S', 19, 64, 56], ['M', 20, 68, 60], ['L', 21, 72, 64], ['XL', 22, 76, 68]
      ] }]
    },
    {
      slug: 'veil-racerback-bra',
      name: 'VEIL™ Racerback Bra',
      group: 'Bras',
      note: 'Deep V racerback · JYWX1339',
      match: ['veil™ racerback bra'],
      tables: [{ columns: ['Size', 'Length', 'Bust', 'Bottom'], rows: [
        ['XS', 27.4, 65, 55], ['S', 28.2, 69, 59], ['M', 29, 73, 63], ['L', 29.8, 77, 67], ['XL', 30.6, 81, 71]
      ] }]
    },
    {
      slug: 'veil-halter-tank-top',
      name: 'VEIL™ Halter Tank Top',
      group: 'Tops',
      note: 'V neck halter · JYBX1346',
      match: ['veil™ halter tank top'],
      tables: [{ columns: ['Size', 'Length', 'Bust', 'Bottom'], rows: [
        ['XS', 49.2, 60, 61], ['S', 51, 64, 65], ['M', 52.8, 68, 69], ['L', 54.6, 72, 73], ['XL', 56.4, 76, 77]
      ] }]
    },
    {
      slug: 'veil-long-sleeve-shrug',
      name: 'VEIL™ Long Sleeve Shrug',
      group: 'Tops',
      note: 'Long sleeve wrap shrug · JYPJ1339',
      match: ['veil™ long sleeve shrug'],
      tables: [{ columns: ['Size', 'Length', 'Bust', 'Shoulder', 'Sleeve'], rows: [
        ['XS', 24.3, 65, 31, 58], ['S', 24.9, 69, 32, 59], ['M', 25.5, 73, 33, 60], ['L', 26.3, 77, 34, 61], ['XL', 27.1, 81, 35, 62]
      ] }]
    },
    {
      slug: 'sculpt-zip-jacket',
      name: 'SCULPT™ Zip Jacket',
      group: 'Outerwear',
      note: 'Seamless full zipper · JY7896',
      match: ['sculpt™ zip jacket'],
      tables: [{ columns: ['Size', 'Length', 'Bust', 'Bottom', 'Sleeve'], rows: [
        ['XS', 50, 67, 68, 61], ['S', 51, 72, 73, 62], ['M', 52, 77, 78, 63], ['L', 53, 82, 83, 64], ['XL', 54, 87, 88, 65]
      ] }]
    },
    {
      slug: 'sculpt-scrunch-leggings',
      name: 'SCULPT™ Scrunch Leggings',
      group: 'Leggings',
      note: 'Seamless scrunch · JY 5498 · 23" inseam',
      match: ['sculpt™ scrunch leggings'],
      tables: [{ columns: ['Size', 'Length', 'Waist', 'Hip', 'Inseam'], rows: [
        ['XS', 78, 52, 66, 57.5], ['S', 80, 56, 70, 59], ['M', 82, 60, 74, 60.5], ['L', 84, 64, 78, 62], ['XL', 86, 68, 82, 63.5]
      ] }]
    },
    {
      slug: 'veil-signature-leggings',
      name: 'VEIL™ Signature Leggings',
      group: 'Leggings',
      note: 'High-waisted · JY CK1352 · 25" inseam',
      match: ['veil™ signature leggings'],
      tables: [{ columns: ['Size', 'Length', 'Waist', 'Hip'], rows: [
        ['XS', 87.5, 45, 71], ['S', 89, 49, 75], ['M', 90.5, 53, 79], ['L', 92, 57, 83], ['XL', 93.5, 61, 87]
      ] }]
    },
    {
      slug: 'veil-straight-leg-pants',
      name: 'VEIL™ Straight Leg Pants',
      group: 'Leggings',
      note: 'High waist flared · JYCK1339 · 31" inseam',
      match: ['veil™ straight leg pants'],
      tables: [{ columns: ['Size', 'Length', 'Extended length', 'Waist', 'Hip'], rows: [
        ['XS', 101, 105, 45, 78], ['S', 102.5, 107, 49, 82], ['M', 104, 109, 53, 86], ['L', 105.5, 110, 57, 90], ['XL', 107, 112, 61, 94]
      ] }]
    },
    {
      slug: 'veil-signature-shorts',
      name: 'VEIL™ Signature Shorts',
      group: 'Shorts',
      note: 'High waist · JYDK41 · 4.5" inseam',
      match: ['veil™ signature shorts'],
      tables: [{ columns: ['Size', 'Length', 'Waist', 'Hip'], rows: [
        ['XS', 32, 45, 70], ['S', 33, 49, 74], ['M', 34, 53, 78], ['L', 35, 57, 82], ['XL', 36, 61, 86]
      ] }]
    }
  ];

  var howToMeasure = [
    { term: 'Bust', detail: 'Measure around the fullest part of your chest, keeping the tape level and relaxed.' },
    { term: 'Under bust', detail: 'Measure directly beneath your bust, where a bra band would sit.' },
    { term: 'Waist', detail: 'Measure the narrowest part of your natural waist, usually just above the navel.' },
    { term: 'Hip', detail: 'Stand with feet together and measure around the fullest part of your hips.' },
    { term: 'Inseam', detail: 'Measure from the crotch seam straight down to the bottom hem of the leg.' },
    { term: 'Length', detail: 'Measured from the highest point of the garment straight down to the hem.' }
  ];

  function getChartForStyle(styleName) {
    if (!styleName) return null;
    var s = styleName.toLowerCase();
    for (var i = 0; i < sizeCharts.length; i++) {
      var matches = sizeCharts[i].match;
      for (var j = 0; j < matches.length; j++) {
        if (s.indexOf(matches[j]) !== -1) return sizeCharts[i];
      }
    }
    return null;
  }

  return { sizeCharts: sizeCharts, howToMeasure: howToMeasure, getChartForStyle: getChartForStyle };
})();
